import React from 'react';

export const Loader = props=>(
    <div className={`Loader`}>
        <div className={`LoadIcon`}>
            <div className={`LoadIcon-Inner`}/>
        </div>
    </div>
);